<template>
  <div id="app">
    <!-- <Nav /> -->
    <router-view />
  </div>
</template>

<script>
// import Nav from './components/nav';
export default {
  name: 'App',
  components: {}
};
</script>

<style>
* {
  list-style: none;
  text-decoration: none;
}
html,
body {
  height: 100%;
  padding-top: 40px;
  margin: 0;
}
#app {
  width: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue